import { ref } from 'vue';
import { Organization } from '@/entities/organization';
import { emptyOrganization } from '@/ui/auth/emptyOrganization';

export const organization = ref<Organization>(emptyOrganization());
